import { render, staticRenderFns } from "./PaginationMessage.vue?vue&type=template&id=2d76d4f2&scoped=true"
import script from "./PaginationMessage.vue?vue&type=script&lang=js"
export * from "./PaginationMessage.vue?vue&type=script&lang=js"
import style0 from "./PaginationMessage.vue?vue&type=style&index=0&id=2d76d4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76d4f2",
  null
  
)

export default component.exports